import { Box, Typography, styled, useTheme } from "@mui/material"
import type { HealthMissionCategoryName } from "@pharmupp/p3-front-commons"
import { HealthMissionCategoryIcon } from "./healthMissionIcons.referential"

export const HealthMissionCategoryHeader = ({
  name,
  label,
}: {
  name: HealthMissionCategoryName
  label: string
}) => {
  const { palette } = useTheme()
  const Icon = HealthMissionCategoryIcon[name]

  return (
    <CategoryHeaderRow>
      <IconContainer>
        <Icon size={20} color={palette.primary.contrastText} />
      </IconContainer>
      <Header>{label}</Header>
    </CategoryHeaderRow>
  )
}

const Header = styled(Typography)(({ theme: { palette } }) => ({
  lineHeight: 1,
  fontWeight: 500,
  color: palette.primary.dark1,
}))
Header.defaultProps = {
  variant: "20px",
}

const CategoryHeaderRow = styled(Box)(({ theme: { palette, spacing } }) => ({
  display: "flex",
  alignItems: "center",
  gap: spacing(1.25),
  paddingBottom: spacing(1.5),
  borderBottom: `1px solid ${palette.grey.extraLight}`,
}))

const IconContainer = styled(Box)(({ theme: { palette } }) => ({
  display: "grid",
  placeContent: "center",
  padding: "7px",
  borderRadius: "50%",
  backgroundColor: palette.primary.dark3,
}))
